
const images = (folder, lang) => {
    let listImg = [];
    if (process.env.NODE_ENV === 'development') {
        for(let i = 0; i < 294; i++){
            listImg.push(`http://localhost:8081/media/${lang}/saphirVideo3/compteur_saphir_site_${i.toString().padStart(5, '0')}.jpg`)
        }
    } else {
        for(let i = 0; i < 294; i++){
            listImg.push(`https://www.dioptase.fr/media/${lang}/saphirVideo3/compteur_saphir_site_${i.toString().padStart(5, '0')}.jpg`)
        }
    }
    return listImg;
}
export default images;
